// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__2cl8o","buttons":"Password_buttons__1CWWQ"};